import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { makeCoreGetRequest } from "utils/api"
import { useNotification } from "hooks"
import { formatErrorMessage } from "utils/formatting"
import { Dialog, Grid } from "@mui/material"
import { useQuery } from "react-query"
import { resourceToSrc, toPictureTypeLabelRo } from "./helpers"

const Images = ({ isHistorical }) => {
  const { showNotification } = useNotification()
  const [images, setImages] = useState([])
  const [objectUrls, setObjectUrls] = useState([])
  const [selectedImage, setSelectedImage] = useState(null)

  const { id } = useParams()

  const { data: pictureModels } = useQuery(
    ['images', id],
    async () => {
      if (!id) return null;
      const path = isHistorical
        ? `/shop-reception/ds-pictures/${id}`
        : `/shop-reception/ds-pictures/${id}`
      return await makeCoreGetRequest(path)
    },
    {
      onError: error => {
        setImages([])
        showNotification({
          message: `A apărut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  useEffect(() => {
    objectUrls.forEach((u) => URL.revokeObjectURL(u))
    setObjectUrls([])

    if (!pictureModels || !Array.isArray(pictureModels)) {
      setImages([])
      return
    }

    const next = []
    const newBlobUrls = []

    for (const [idx, item] of pictureModels.entries()) {
      const fileName = item?.fileName || `img_${idx + 1}`
      const contentType = item?.contentType
      const src = resourceToSrc(item?.resource, fileName, contentType)

      if (src && src.startsWith("blob:")) newBlobUrls.push(src)

      const pictureType = item?.pictureType
      const pictureTypeLabel = toPictureTypeLabelRo(pictureType)

      next.push({
        fileName,
        src: src || "images/imageNotAvailable.png",
        hasResource: Boolean(src),
        pictureType,
        pictureTypeLabel,
      })
    }

    setImages(next)
    setObjectUrls(newBlobUrls)

    return () => {
      newBlobUrls.forEach((u) => URL.revokeObjectURL(u))
    }
  }, [pictureModels])

  return (
    <>
      <Grid container spacing={2}>
        {images.map(image => (
          <Grid item key={image.fileName} xs={12} sm={6} md={4}>
            <div style={{ marginBottom: 8 }}>
              <div style={{ fontWeight: 500 }}>{image.fileName}</div>
              <div style={{ fontSize: 12, opacity: 0.75 }}>
                Tip imagine: {image.pictureTypeLabel}
              </div>
            </div>
            <div
              onClick={() => {
                if (image.hasResource) { setSelectedImage(image) }
              }}
              style={{ cursor: image.hasResource ? "pointer" : "default" }}
            >
              <img
                src={image.src}
                alt={image.fileName}
                style={{
                  width: "100%",
                  height: 280,
                  objectFit: "contain",
                  borderRadius: 8,
                  border: "1px solid #eee",
                }}
              />
            </div>
          </Grid>
        ))}

        {images.length === 0 && (
          <Grid item xs={12}>
            <div style={{ opacity: 0.7 }}>Nu există imagini de afișat.</div>
          </Grid>
        )}

        <Dialog open={!!selectedImage} onClose={() => setSelectedImage(null)} maxWidth="lg">
          {selectedImage && (
            <img src={selectedImage.src} alt={selectedImage.fileName} style={{ maxWidth: '90vw', maxHeight: '90vh' }} />
          )}
        </Dialog>
      </Grid>
    </>
  )
}

export default Images
